import Pilot from 'system/libs/Pilot';

const router = {
    init(routes, target) {
        const pilot = Pilot.create(routes);

        pilot.listenFrom(target, {
            autoStart: true,
            filter(url) {
                // Allow anchor navigation on pages
                if (url.includes('#')) {
                    return false;
                }

                const pathname = new Pilot.URL(url).pathname;
                return /^(\/partner)?\/app\//.test(pathname);
            },
        });

        this._proxy(pilot);
    },

    /**
     * Проксирует все методы и свойства инстанса pilot в объект router,
     * чтобы в остальных модулях использовать роутер следующим образом:
     *     var router = require('./router');
     *     router.go('#route-id');
     */
    _proxy(pilot) {
        Object.setPrototypeOf(this, pilot);

        Object.keys(Pilot.prototype).forEach(function(key) {
            if (typeof Pilot.prototype[key] === 'function') {
                this[key] = function() {
                    // eslint-disable-next-line prefer-spread,prefer-rest-params
                    return pilot[key].apply(pilot, arguments);
                };
            }
        }, this);
    },

    redirectTo(routeId, params, query, details) {
        this.go(routeId, params, query, {
            ...details,
            replaceState: true,
        });
    },

    getRoute(routeId) {
        return this.routes.find((route) => {
            return route.id === routeId;
        });
    },

    isPartnerAppUrl(url) {
        return String(url).startsWith('/partner/app');
    },

    isPartnerAppRequest(request) {
        return request && this.isPartnerAppUrl(request.path);
    },

    isPartnerAppRoute(route) {
        return (
            route &&
            route.url &&
            route.url.pattern &&
            this.isPartnerAppUrl(route.url.pattern)
        );
    },

    isPartnerApp() {
        return (
            this.isPartnerAppRoute(this.activeRoute) ||
            this.isPartnerAppRequest(this.activeRequest)
        );
    },
};

export default router;
